// 公共方法
const PubMix = {
    methods: {
        // 跳转到路径
        goto (url, otype) {
            if ( otype == '_blank' ) {
                this.open( url )
            } else if ( url === -1 ) {
                this.$router.go( -1 )
            } else {
                this.$router.push( url )
            }
        },

        open ( url ) {
            const routeData = this.$router.resolve(url);
            window.open(routeData.href, '_blank');
        },

        onImgError () {
            return true
        }
    },
    computed: {
        dimg () {
            return {
                circleUser:"https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
                squareUser:"https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png",
            }

        }
    }
}

export default PubMix